import { Injectable } from "@angular/core";
import { HttpClient } from "../http/http-client";

@Injectable()
export class CustomFieldsService {
  constructor(private httpClient: HttpClient) {}

  async getCustomFields(bookingId: string, modelType: string) {
    const url = `api/v1/homekeeper/customer-custom-fields/${bookingId}?model_type=${modelType}`;
    return this.httpClient.get(url);
  }

  getCustomFieldsForDetails(customFields, details) {
    try {
      if (!customFields) {
        return [];
      }

      // Handle both direct array and object with custom fields array
      let fieldsArray = [];
      if (Array.isArray(customFields)) {
        fieldsArray = customFields;
      } else if (customFields.customer_custom_fields && Array.isArray(customFields.customer_custom_fields)) {
        fieldsArray = customFields.customer_custom_fields;
      } else if (customFields.user_custom_fields && Array.isArray(customFields.user_custom_fields)) {
        fieldsArray = customFields.user_custom_fields;
      } else if (customFields.custom_fields && Array.isArray(customFields.custom_fields)) {
        fieldsArray = customFields.custom_fields;
      }

      if (fieldsArray.length === 0) {
        return [];
      }

      if (!details) {
        details = {};
      }
      return fieldsArray
        .filter((customField) => {
          // Only process fields that are visible to homekeeper
          return customField?.is_visible_to_homekeeper === true || customField?.is_visible_to_homekeeper === 'true';
        })
        .map((customField) => {
          const key = customField.field_key;
          const value = (details[key] !== null && details[key] !== undefined) ? details[key] : customField.default_value;

          // Skip if value is null or undefined (but allow false for boolean fields)
          if (value === null || value === undefined || value === '') {
            return null;
          }

          // Format the value based on field type
          let displayValue = value;
          if (customField.field_type === 'boolean') {
            displayValue = value === true || value === 'true' ? 'Yes' : 'No';
          }

          return `${customField.field_name}: ${displayValue}`;
        })
        .filter((field) => field !== null && field !== '');
    } catch (err) {
      console.error(err);
      return [];
    }
  }
}
